let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("vO1Dg")).then(() => parcelRequire('hx1Fj'));